import './LegalSubTitle.styles.scss';
import { LegalSubTitleProps } from '../Legal.types';

function LegalSubTitle({ subTitle }: LegalSubTitleProps) {
  return <h4 className={'legal-subtitle'}>{subTitle}</h4>;
}

export default LegalSubTitle;
